module.exports = __webpack_public_path__ + "img/02.25ff9c8c.jpg";